// api
import { fetchApi } from '@/api'
import router from '@/router'

const controlaccesopermisslist = (context, array) => {
  let url = 'admin/savepermiso'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CONTROL_ACCESO_PERMISS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error)
    })
}

const controlaccesopermisslistenviar = (context, array) => {
  let url = 'admin/crearpermiso'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CONTROL_ACCESO_PERMISS_LIST_CREAR', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error)
    })
}

export default {
  controlaccesopermisslist,
  controlaccesopermisslistenviar
}



// WEBPACK FOOTER //
// ./src/store/modules/controlacceso/permiss/actions.js